// extracted by mini-css-extract-plugin
export default {"container":"formal_field_container__ZRiEB"};